import { render, staticRenderFns } from "./ClassReviewDetails.vue?vue&type=template&id=addfad20&scoped=true"
import script from "./ClassReviewDetails.vue?vue&type=script&lang=js"
export * from "./ClassReviewDetails.vue?vue&type=script&lang=js"
import style0 from "./ClassReviewDetails.vue?vue&type=style&index=0&id=addfad20&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "addfad20",
  null
  
)

export default component.exports